import { Component, OnInit } from '@angular/core';
import { ActivityEditorBaseComponent } from '../../activity-editor-base/activity-editor-base.component';

@Component({
    selector: 'wm-renewal-review-activity-editor',
    templateUrl: './review-activity-editor.component.html',
    styleUrls: ['./review-activity-editor.component.css'],
    standalone: false
})
export class ReviewActivityEditorComponent
  extends ActivityEditorBaseComponent
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
